import React from 'react';
import RecentMessages from '../components/RecentMessages';

const Inbox = () => {
  return (
    <div className="py-6 h-full">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8 h-full flex flex-col">
        <h1 className="text-2xl font-semibold text-gray-900 mb-6">Bandeja de WhatsApp</h1>
        {/* Chat container with fixed height */}
        <div className="flex-1 min-h-0"> {/* min-h-0 is crucial for nested flex containers */}
          <RecentMessages />
        </div>
      </div>
    </div>
  );
};

export default Inbox; 